import React, { Component } from 'react';
import Terminal from 'react-bash';

export const intro = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: ">_ Hey!, I'm Ranjit" })
                .concat({ value: '>_ A software developer and a learner who urges to learn till the last breath' })
                .concat({ value: '>_ also a video editor sometimes i make people laugh with my funny videos' })
        };
    }
};

export const edu = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: '>_ B.tech (Computer Science)' })
                .concat({ value: '>_ AIACTR,NSUT east campus (6.5/10) ' })
                .concat({ value: '>_' })
                .concat({ value: '>_ 12th (PCM)' })
                .concat({ value: '>_ A.S.V.J Sr. Sec. School (84/100)' })
                .concat({ value: '>' })
                .concat({ value: '>_ 10th ' })
                .concat({ value: '>_ Victoria Sr. Sec. School (8.6/10)' })
                .concat({ value: '>' })
        };
    }
};

export const pskill = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: ">_ C/C++"})
                .concat({ value: '>_ Javascript' })
                .concat({ value: '>_ Typescript' })
                .concat({ value: '>_ Data Structures & Algorithms' })
                .concat({ value: '>_ OOPS' })
                .concat({ value: '>' })
        };
    }
};

export const project = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: '>_ Gamoby : a self-merchandising web-app' })
                .concat({ value: '>_ Url: http://www.gamoby.in/' })
                .concat({ value: '>' })
                .concat({ value: '>_ Covip-App : shows Corona cases,bed and hospital counts State-wise' })
                .concat({ value: '>_ Url: https://covid19.ranjitkshah.vercel.app/' })
                .concat({ value: '>' })
                .concat({ value: '>_ Pubg-API : shows in-game guns and equipments Data in JSON ' })
                .concat({ value: '>_ Url: http://ranpubgapi.herokuapp.com/' })
                .concat({ value: '>' })
                .concat({ value: '>_ Relax-app : app helps to relax and meditate with nature ' })
                .concat({ value: '>_ Url: https://relax-app.ranjitkshah.vercel.app/' })
                .concat({ value: '>' })
                
        };
    }
};

export const devskill = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({
                    value: '>_ Now, working on react and node js'
                })
                .concat({ value: '>_ ' })
                .concat({ value: '>_ Backend  => nodejs,Django(rest-framework)' })
                .concat({ value: '>_ Frontend => react js,next js' })
                .concat({ value: '>_ Database => MySQL, PostgreSQL, MongoDb , Firebase' })
                .concat({ value: '>_ ' })
                .concat({ value: '>_ Other TOOLS' })
                .concat({
                    value: '>_ Git,Heroku'
                })
                .concat({ value: '>_ ' })
                .concat({ value: '>_ INTERESTED NOW' })
                .concat({ value: '>_ AR(Augmented Reality)' })
                .concat({ value: '>' })
        };
    }
};

export const sskill = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: '>_ Editing => Sony vegas pro,Adobe illustrator,Adobe Photoshop)' })
                .concat({ value: '>_ AR filter => Spark AR studio' })
                .concat({ value: '>_ UI Design => Figma' })
                .concat({ value: '>' })
        };
    }
};


export const exp = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: '>_ feb 2020 - apr 2020 : Gamoby India, Backend-Developer (founder)'})
                .concat({ value: '>_ oct 2019 - dec 2020 : Javin Digital Agency, Intern as Frontend-Developer' })
                .concat({ value: '>' })
        };
    }
};

export const contact = {
    exec: ({ structure, history, cwd }, command) => {
        return {
            structure,
            cwd,
            history: history
                .concat({ value: '>_ Email : ranjitmaheshshah@gmail.com' })
                .concat({ value: '>_ Instagram : @ranjitkshah' })
                .concat({ value: '>_ linkedin : linkedin.com/in/ranjit-shah-b94b7a1a8/' })
                .concat({ value: '>_ Github : github.com/ranjitkshah' })
                .concat({ value: '>' })
        };
    }
};

class terminal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const extensions = {
            intro,
            edu,
            pskill,
            devskill,
            project,
            sskill,
            exp,
            contact
        };
        const history = [{ value: 'Welcome to my profile!' }].concat({
            value: 'Please type the command'
        });
        return <Terminal prefix={'portfolio'} theme={Terminal.Themes.DARK} history={history} extensions={extensions} />;
    }
}

export default terminal;
